

define(['squid/index'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomodel.cartbuttonparams', ['squid']).factory('$CartButtonParamsModel', function ($Model, $Api) {
        return $Model.extend('$CartButtonParamsModel', {
            api: new $Api({
                uri: '/api/cartbuttonparams',
                postAttempts: 2,
                cache: true
            })
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/cartButtonParams/index.js
// module id = ./components/xo-models/src/cartButtonParams/index.js
// module chunks = 1